export const nameSelector = (name: string) => `[name="${name}"]`

/**
 * Registers a listener to changes of the checkbox values
 * @param checkboxName name Attribute of the Checkbox
 * @param onChange Handler for changes
 */
export function onCheckboxValueChange(
    checkboxName: string,
    onChange: (e: string) => void
) {
    const orderTypeCheckboxes = document.querySelectorAll(
        nameSelector(checkboxName)
    )

    for (const orderType of orderTypeCheckboxes) {
        orderType.addEventListener("change", (e) => {
            const element = e.target as HTMLInputElement

            if (element.checked) {
                onChange(element.value)
            }
        })
    }
}

export function onCheckboxChange(
    selector: string,
    onChange: (e: boolean) => void
) {
    const items = document.querySelectorAll(selector)

    for (const item of items) {
        item.addEventListener("change", (e) => {
            const element = e.target as HTMLInputElement
            onChange(element.checked)
        })
    }
}

/**
 * Checks for the current value of the checkbox
 * @param name name Attribute of the checkbox
 * @returns current value (or null)
 */
export function getCurrentRadioValue(name: string) {
    const element = document.querySelector(
        `${nameSelector(name)}:checked`
    ) as HTMLInputElement
    return element?.value
}

/**
 * Typed wrapper for Query Select
 * @param selector Query Selector
 * @returns Node List
 */
export function querySelect<TTarget extends Element>(
    selector: string
): NodeListOf<TTarget> {
    return document.querySelectorAll(selector) as NodeListOf<TTarget>
}
